var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hi-sub-page',[_c('hi-page-column',{attrs:{"card":"","grow":""}},[_vm._v(" Day ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }